import { SafeAreaViewProps } from "./types";

export const SafeAreaView = ({ children }: SafeAreaViewProps) => {
  return children;
};
